import React, { useState, useEffect, useRef } from "react";
// import "codemirror/lib/codemirror.css";
import CodeMirror from "@uiw/react-codemirror";
import { okaidia } from "@uiw/codemirror-theme-okaidia";
import { javascript, esLint } from "@codemirror/lang-javascript";
import { undoDepth, redoDepth } from "@codemirror/commands";
import { linter, lintGutter, forEachDiagnostic } from "@codemirror/lint";
// import axios from "axios";
import * as eslint from "eslint-linter-browserify";
import { instance } from "../../services/axiosConfig";

const JSComponent = ({
  setJSCodeEditor,
  checkErrors,
  setcheckErrors,
  currentSlideRef,
  deckData,
  switchCustomJs,
  defaultActiveTab,
  setUndoAvailable,
  setRedoAvailable,
}) => {
  const [code, setCode] = useState('');
  // const view = EditorView;

  useEffect(() => {
    let IDRef =
      JSON.stringify(currentSlideRef?.current?.child) === "{}"
        ? currentSlideRef?.current?.master?.slideid?._id
        : currentSlideRef?.current?.child?.slideid?._id;
    async function getLocalJs() {
      let resp = await instance.get(`/slides/${IDRef}`).then(({ data }) => {
        if (data?.custom_script){
          if (data.custom_script?.url) setCode(data.custom_script?.script);
        }else{ 
          setCode(' ')
        }
          
      });
    }

    async function getGlobalJs(){
      let response =  await instance.get(`/decks/${deckData._id}`).then(({data})=>{
         if(data.deck_shared_assets?.global?.js?.url) 
           setCode(data?.deck_shared_assets?.global?.js.content);
         else setCode('');
 
         //setIsloading(false);
       })
    }

    if(deckData !== null && switchCustomJs){
      //setIsloading(true);
      setCode('Loading Content....')
      getGlobalJs()
    }else{
      //setIsloading(true);
      getLocalJs();
    }
    setJSCodeEditor(JSRef);
  }, [switchCustomJs]);

  useEffect(()=>{
    let IDRef =
      JSON.stringify(currentSlideRef?.current?.child) === "{}"
        ? currentSlideRef?.current?.master?.slideid?._id
        : currentSlideRef?.current?.child?.slideid?._id;
        
    async function getGlobalJs(){
        await instance.get(`/decks/${deckData._id}`).then(({data})=>{
         if(data.deck_shared_assets?.global?.js?.url) 
           setCode(data?.deck_shared_assets?.global?.js.content);
       })
    }

    async function getLocalJs() {
      await instance.get(`/slides/${IDRef}`).then(({ data }) => {
        if (data?.custom_script){
          if (data.custom_script?.url) setCode(data.custom_script?.script);
        }
          
      });
    }
    if(defaultActiveTab !== "JS") {
      setCode("");
    } else {
      // getGlobalJs();
      // if(deckData !== null && switchCustomJs){
      //   //setIsloading(true);
      //   setCode('Loading Content....')
      //   getGlobalJs()
      // }else{
      //   //setIsloading(true);
        getLocalJs();
      // }
      setJSCodeEditor(JSRef);
  }
  },[defaultActiveTab]);

  const JSRef = useRef();
  useEffect(() => {
    if (!JSRef.current.view) return;
    getJSErrors();
    
    const undoDepthCount = undoDepth(JSRef.current?.view?.state);
    setUndoAvailable(undoDepthCount>0);
    const redoDepthCount = redoDepth(JSRef.current?.view?.state);
    setRedoAvailable(redoDepthCount>0);
  }, [code]);

  const config = {
    parserOptions: {
      ecmaVersion: 2019,
      sourceType: "module",
    },
    env: {
      browser: true,
      node: true,
      jquery: true,
    },
    extends: "eslint:recommended",
    rules: {
      // enable additional rules
      indent: ["warn", 4],
      "linebreak-style": ["warn", "unix"],
      // "no-debugger ": ["error"],
      quotes: ["warn", "double"],
      semi: ["warn", "always"],
      // override configuration set by extending "eslint:recommended"
      "no-empty": "warn",
      "no-undef": ["error"],
      "no-cond-assign": ["error", "always"],
      // disable rules from base configurations
      "for-direction": "off",
    },
    // hintOptions: {
    //   hint: CodeMirror.hint.javascript,
    //   globalScope: {
    //     $: true, // Define $ as a global variable (jQuery)
    //     jQuery: true, // Define jQuery as a global variable
    //   },
    // },
  };

  const handleErrors = (errorList, from, to) => {
    let error =
      errorList.severity === "error"
        ? setcheckErrors({ ...checkErrors, js: true })
        : "";
  };

  var options = {
    lineNumbers: true,
    lineWrapping: true,
    autoBeautify: true,
    autoCloseTags: true,
    autoCloseBrackets: true,
  };
  const getJSErrors = () => {
    if (!JSRef.current.view) return;

    // setErrors([]);
    const testFun = forEachDiagnostic(
      JSRef.current.view.viewState.state,
      handleErrors
    );
  };
  return (
    <div>
      <CodeMirror
        height="calc(100vh - 154px)"
        ref={JSRef}
        value={code}
        extensions={[
          javascript({ js: true }),
          lintGutter(),
          linter(esLint(new eslint.Linter(), config)),
        ]}
        theme={okaidia}
        // onBeforeChange={(editor, data, code) => {
        //  // console.log(test, "test");
        //   setCode({ code });
        // }}
        onChange={(updatedCode) => {
          setCode(updatedCode);
        }}
        options={options}
      />
    </div>
  );
};
export default JSComponent;
